// Shared helpers for viral sharing (WhatsApp / Reddit / Discord + copy).
export const DECK_SHARE_MSG = (url) =>
  `Hey, I just turned our class PDF into a horizontal study deck using LoomPDF. You can review it here: ${url}`;

export const REFERRAL_MSG = (url) =>
  `Need more free uploads? I'm using LoomPDF to turn class PDFs into horizontal study decks. Try it with my link and we both get 3 bonus uploads: ${url}`;

export const waHref = (text) => `https://wa.me/?text=${encodeURIComponent(text)}`;
export const redditHref = (url, title) =>
  `https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Fallback for non-secure contexts
    const ta = document.createElement("textarea");
    ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0";
    document.body.appendChild(ta); ta.select();
    let ok = false;
    try { ok = document.execCommand("copy"); } catch {}
    ta.remove();
    return ok;
  }
}
